import { render, staticRenderFns } from "./logisticsDelivery.vue?vue&type=template&id=bac60cec&scoped=true&"
import script from "./logisticsDelivery.vue?vue&type=script&lang=js&"
export * from "./logisticsDelivery.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDelivery.vue?vue&type=style&index=0&id=bac60cec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac60cec",
  null
  
)

export default component.exports